export const ENROLLMENT_REQUIRED = 'ENROLLMENT_REQUIRED'
export const BS_CONTRACT_ACCEPTANCE_REQUIRED = 'BS_CONTRACT_ACCEPTANCE_REQUIRED'
export const MS_CONTRACT_ACCEPTANCE_REQUIRED = 'MS_CONTRACT_ACCEPTANCE_REQUIRED'
export const VERIFY_EMAIL = 'VERIFY_EMAIL'
export const UPDATE_PASSWORD = 'UPDATE_PASSWORD'
